/**
 * Portal Manta · agGeradorOrc
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { sumBy } from '../../globals.js';

function agGeradorOrc(ctx, prev){
  const {kpis, loteRef, baseLotes} = ctx;
  if (!loteRef) return {status:'sem-ref'};
  const cats = [
    {k:'dup',l:'Duplicações',q:kpis.dupKm,und:'km'},
    {k:'marg',l:'Marginais',q:kpis.margKm,und:'km'},
    {k:'cicl',l:'Ciclovias',q:kpis.ciclKm,und:'km'},
    {k:'oae',l:'OAEs',q:kpis.oaeQt,und:'un'},
    {k:'pass',l:'Passarelas',q:kpis.passQt,und:'un'},
    {k:'inter',l:'Interseções',q:kpis.interQt,und:'un'},
  ];
  const med = (c) => baseLotes.reduce((s,l)=>s+(l.pu[c]||0),0)/Math.max(baseLotes.length,1);
  const rotaA = cats.map(c => ({...c, pu: loteRef.pu[c.k]||0, custo: c.q*(loteRef.pu[c.k]||0)}));
  const rotaB = cats.map(c => ({...c, pu: med(c.k), custo: c.q*med(c.k)}));
  const subA = sumBy(rotaA,'custo');
  const subB = sumBy(rotaB,'custo');
  return {
    sub:'Gerador de Orçamento',
    status:'ok',
    rotaA, rotaB, subA, subB,
    deltaAB: subB>0?(subA-subB)/subB*100:0,
    med:(subA+subB)/2, min:Math.min(subA,subB), max:Math.max(subA,subB),
    msg: `Estimativa: R$ ${((subA+subB)/2/1e6).toFixed(0)} mi · Δ ${(subB>0?(subA-subB)/subB*100:0).toFixed(1)}%`,
  };
}

export { agGeradorOrc };
export default agGeradorOrc;
